/**
 * Ryan O'Dowd
 * 2022-06-03
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  const innerBackgroundColor = isDarkMode ? colors.primaryExtraDark : colors.primary; // @TODO: combine with ListItem styles
  const borderColor = isDarkMode ? colors.primary : colors.primaryLight; // @TODO: combine with ListItem styles

  return {
    levelNumberBadge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.primaryLight,
      minWidth: 20,
      padding: globalScale * 2,
      margin: globalScale * 2,
      marginRight: globalScale * 0,
      paddingHorizontal: globalScale * 4,
      borderRadius: globalScale * 4,
    },
    levelNumberBadgeText: {
      color: colors.white,
      fontSize: globalScale * 12,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignSelf: 'center',
      backgroundColor: innerBackgroundColor,
      borderRadius: globalScale * 8,
      borderColor,
      borderWidth: globalScale * 2,
    },
    pausedWrinkleContainer: {
      backgroundColor: 'transparent',
      opacity: 0.65,
    },
    containerExpanded: {
      width: '100%',
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignSelf: 'center',
    },
    titleContainerExpanded: {
      width: '100%',
    },
    chipText: {
      fontSize: globalScale * 14,
      color: colors.white,
      padding: globalScale * 4,
      paddingHorizontal: globalScale * 6,
      fontFamily: fonts.primaryBold,
    },
    chipTextExpanded: {
      fontSize: globalScale * 18,
      paddingVertical: globalScale * 4,
    },
  };
};

export default getStyles;
